import { render, staticRenderFns } from "./MainImportPage.vue?vue&type=template&id=e9a444ba&scoped=true&"
import script from "./MainImportPage.vue?vue&type=script&lang=js&"
export * from "./MainImportPage.vue?vue&type=script&lang=js&"
import style0 from "./MainImportPage.vue?vue&type=style&index=0&id=e9a444ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a444ba",
  null
  
)

export default component.exports